import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  description: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
  },
  error: {
    color: "#F04438",
    fontStyle: "italic",
  },
}));

export default styles;
